// ========== FRONTEND (React Component) ==========
import React, { Component, createRef } from "react";
import { Row, Col, FormGroup, Label, Input, Spinner, Button } from "reactstrap";
import "./infojabatan.css";

import DetailBloc from "../Blocs/DetailBloc";
import { cancelToken } from "../../../../../services/adapters/kepegawaian/menuService";
import apiResponse from "../../../../../services/apiResponse";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";
import { Link, useHistory, Redirect } from "react-router-dom";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
} from "availity-reactstrap-validation";

import CustomSelect from "../../../GlobalComponents/CustomSelect";

const SUB_TABS = [
  "Data Jabatan",
  "Tugas Pokok",
  "Hasil Kerja",
  "Bahan Kerja",
  "Perangkat Kerja",
  "Tanggung Jawab",
  "Wewenang",
  "Korelasi Jabatan",
  "Kondisi Ling. Kerja",
  "Resiko Bahaya",
  "Syarat Jabatan Lain",
  "Prestasi Kerja Diharapkan",
  "Kelas Jabatan",
];

// Mapping tab ke type_data
const TAB_TYPE_MAPPING = {
  "Data Jabatan": 1,
  "Tugas Pokok": 2,
  "Hasil Kerja": 3,
  "Bahan Kerja": 4,
  "Perangkat Kerja": 5,
  "Tanggung Jawab": 6,
  "Wewenang": 7,
  "Korelasi Jabatan": 8,
  "Kondisi Ling. Kerja": 9,
  "Resiko Bahaya": 10,
  "Syarat Jabatan Lain": 11,
  "Prestasi Kerja Diharapkan": 12,
  "Kelas Jabatan": 13,
};

class InfoJabatanComponent extends Component {
  constructor(props) {
    super(props);

    this.jabatanBloc = new DetailBloc();
    this.sourceRef = createRef();

    this.state = {
      activeSubTab: "Data Jabatan",
      loading: false,
      dataForm: {},
      detail: {},
      detailData: {},
      form: {
        namaJabatan: "",
        jenisJabatan: "1",
        kodeJabatan: "",
        ikhtisarJabatan: "",
        tugasPokok: "",
        hasilKerja: "",
        bahanKerja: "",
        perangkatKerja: "",
        tanggungJawab: "",
        wewenang: "",
        korelasiJabatan: "",
        kondisiLingKerja: "",
        resikoBahaya: "",
        syaratJabatanLain: "",
        prestasiKerja: "",
        kelasJabatan: "",
      },
      datajabatannew : [
          { value : 1, label : "Jabatan Fungsional"},
          { value : 2, label : "Jabatan Struktural"},
          { value : 3, label : "Jabatan Pelaksana"}
      ]
    };
  }

  componentDidMount() {
    this.loadData(this.props.work_unit);
    this.setupSubscriptions();
  }

  componentDidUpdate(prevProps) {
    const workUnitChanged = this.props.work_unit !== prevProps.work_unit;
    const positionChanged = this.props.position_uuid !== prevProps.position_uuid;

    if (workUnitChanged || positionChanged) {
      this.setState({
        activeSubTab: "Data Jabatan",
        detail: {},
        detailData: {},
        form: {
          namaJabatan: "",
          jenisJabatan: "1",
          kodeJabatan: "",
          ikhtisarJabatan: "",
          tugasPokok: "",
          hasilKerja: "",
          bahanKerja: "",
          perangkatKerja: "",
          tanggungJawab: "",
          wewenang: "",
          korelasiJabatan: "",
          kondisiLingKerja: "",
          resikoBahaya: "",
          syaratJabatanLain: "",
          prestasiKerja: "",
          kelasJabatan: "",
        },
        loading: true
      }, () => {
        this.loadData(this.props.work_unit);
      });

    }
  }


  componentWillUnmount() {
    if (this.sourceRef.current) {
      this.sourceRef.current.cancel();
    }
    if (this.subscriptionInfo) {
      this.subscriptionInfo.unsubscribe();
    }
    if (this.subscriptionDetail) {
      this.subscriptionDetail.unsubscribe();
    }
    if (this.subscriptionCreate) {
      this.subscriptionCreate.unsubscribe();
    }
  }

  setupSubscriptions = () => {
    // Subscription untuk info jabatan (data master)
    this.subscriptionInfo = this.jabatanBloc.infoJabatanChannel.subscribe(
      (result) => {
        switch (result.status) {
          case apiResponse.INITIAL:
            this.setState({ loading: true });
            break;
          case apiResponse.COMPLETED:
            if (result.data.status) {
              let response = result.data.response;
              this.setState({
                detail: response,
                loading: false,
              });
            } else {
              this.setState({ loading: false });
            }
            break;
          case apiResponse.ERROR:
            this.setState({ loading: false });
            break;
          default:
            break;
        }
      }
    );

    // Subscription untuk detail data per tab
    this.subscriptionDetail = this.jabatanBloc.fetchdetailInfoJabatanChannel.subscribe(
      (result) => {
        switch (result.status) {
          case apiResponse.INITIAL:
            this.setState({ loading: true });
            break;
          case apiResponse.COMPLETED:
            if (result.data.status && result.data.response) {
              let response = result.data.response;
              
              // Jika tab 1 dan ada data detail, gunakan data detail
              if (this.state.activeSubTab === "Data Jabatan") {
                this.setState({
                  detailData: response,
                  form: {
                    ...this.state.form,
                    namaJabatan: response.emp_info_position_position_name || "",
                    jenisJabatan: response.emp_info_position_position_type || "1",
                    kodeJabatan: response.emp_info_position_position_code || "",
                    ikhtisarJabatan: response.emp_info_position_job_overview || "",
                  },
                  loading: false,
                });
              } else {
                // Tab 2-13: set job_overview ke field yang sesuai
                const fieldMapping = {
                  2: "tugasPokok",
                  3: "hasilKerja",
                  4: "bahanKerja",
                  5: "perangkatKerja",
                  6: "tanggungJawab",
                  7: "wewenang",
                  8: "korelasiJabatan",
                  9: "kondisiLingKerja",
                  10: "resikoBahaya",
                  11: "syaratJabatanLain",
                  12: "prestasiKerja",
                  13: "kelasJabatan",
                };
                
                const typeData = TAB_TYPE_MAPPING[this.state.activeSubTab];
                const fieldName = fieldMapping[typeData];
                
                if (fieldName) {
                  this.setState({
                    detailData: response,
                    form: {
                      ...this.state.form,
                      [fieldName]: response.emp_info_position_job_overview || "",
                    },
                    loading: false,
                  });
                }
              }
            } else {
              // Jika tidak ada data detail dan tab 1, gunakan data master
              if (this.state.activeSubTab === "Data Jabatan") {
                // Data master sudah di-load di infoJabatanChannel
                this.setState({ 
                  detailData: {},
                  loading: false 
                });
              } else {
                // Tab 2-13 tidak ada data, reset form field
                this.setState({ 
                  detailData: {},
                  loading: false 
                });
              }
            }
            break;
          case apiResponse.ERROR:
            this.setState({ loading: false });
            break;
          default:
            break;
        }
      }
    );

    // Subscription untuk create/update
    this.subscriptionCreate = this.jabatanBloc.fetchcreateInfoJabatanChannel.subscribe(
      (result) => {
        switch (result.status) {
          case apiResponse.COMPLETED:
            this.setState({
              loading: false,
              success: true,
            });
            break;
          case apiResponse.ERROR:
            this.setState({
              gagal_txt: "Gagal!",
              loading: false,
              failed: true,
            });
            break;
          default:
            break;
        }
      }
    );
  };

  setTokenAPI = async (currentWorkUnit, token) => {
    if (!currentWorkUnit) return;
    const query = { uuid: currentWorkUnit, position_uuid : this.props.position_uuid };
    await this.jabatanBloc.fetchInfoJabatan(query, token);
  };

  loadData = (workUnit) => {
    if (!workUnit) {
      this.setState({ loading: false });
      return;
    }
    
    this.setState({ loading: true });

    if (this.sourceRef.current) {
      this.sourceRef.current.cancel();
    }

    const source = cancelToken();
    this.sourceRef.current = source;
    
    // Load data master jabatan
    this.setTokenAPI(workUnit, source.token);
    
    // Load detail data untuk tab aktif
    this.loadDetailByTab();
  };

  loadDetailByTab = async () => {
    const { activeSubTab } = this.state;
    const typeData = TAB_TYPE_MAPPING[activeSubTab];
    
    if (!this.props.work_unit || !this.props.periode || !typeData) {
      return;
    }

    this.setState({ loading: true });

    await this.jabatanBloc.fetchdetailInfoJabatan({
      work_unit_uuid: this.props.work_unit,
      periode_uuid: this.props.periode,
      type_data: typeData,
      position_uuid : this.props.position_uuid ?? ""
    });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      form: {
        ...prevState.form,
        [name]: value,
      },
    }));
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = { confirm: false };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
        };
        // Reload data setelah sukses simpan
        this.loadDetailByTab();
        break;
      case "failed":
        forState = { failed: false };
        break;
      default:
    }
    this.setState(forState);
  };

  submitData = async () => {
    await this.jabatanBloc.fetchcreateInfoJabatan(this.state.dataForm);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    
    const { activeSubTab, form } = this.state;
    const typeData = TAB_TYPE_MAPPING[activeSubTab];
    
    let dataToSubmit = {
      work_unit_uuid: this.props.work_unit,
      periode_uuid: this.props.periode,
      type_data: typeData,
      position_uuid : this.props.position_uuid ?? ""
    };

    if (typeData === 1) {
      dataToSubmit = {
        ...dataToSubmit,
        position_name: values.namaJabatan || form.namaJabatan,
        position_type: values.jenisJabatan || form.jenisJabatan,
        position_code: values.kodeJabatan || form.kodeJabatan,
        job_overview: values.ikhtisarJabatan || form.ikhtisarJabatan,
      };
    } else {
      // Tab 2-13: hanya kirim job_overview
      const fieldMapping = {
        2: "tugasPokok",
        3: "hasilKerja",
        4: "bahanKerja",
        5: "perangkatKerja",
        6: "tanggungJawab",
        7: "wewenang",
        8: "korelasiJabatan",
        9: "kondisiLingKerja",
        10: "resikoBahaya",
        11: "syaratJabatanLain",
        12: "prestasiKerja",
        13: "kelasJabatan",
      };
      const fieldName = fieldMapping[typeData];
      dataToSubmit.job_overview = values[fieldName] || form[fieldName];
    }

    this.setState({
      dataForm: dataToSubmit,
      confirm: true,
    });
  };


  renderDataJabatan = () => {
    const { detail, detailData, form } = this.state;
    
    // Prioritas: detailData (sudah pernah diisi) > detail (data master) > form (kosong)
    const displayData = {
      namaJabatan: detailData.emp_info_position_position_name || detail.position_name || form.namaJabatan,
      jenisJabatan: detailData.emp_info_position_position_type || form.jenisJabatan,
      kodeJabatan: detailData.emp_info_position_position_code || detail.position_uuid || form.kodeJabatan,
      ikhtisarJabatan: detailData.emp_info_position_job_overview || detail.ikhtisar || form.ikhtisarJabatan,
    };

    return (
      <>
        <h5 className="mb-3 fw-bold">Data Jabatan</h5>
        <AvForm
          className="needs-validation"
          onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
        >
          <Row className="mb-3">
            <Col md="6">
              <AvGroup>
                <Label htmlFor="namaJabatan" className="fw-semibold">
                  Nama Jabatan <span className="text-danger">*</span>
                </Label>
                <AvField
                  id="namaJabatan"
                  name="namaJabatan"
                  type="text"
                  readOnly
                  value={displayData.namaJabatan}
                  onChange={this.handleChange}
                  required
                  errorMessage="Nama Jabatan harus diisi"
                />
              </AvGroup>
            </Col>

            <Col md="6">
              <AvGroup>
                <Label htmlFor="jenisJabatan" className="fw-semibold">
                  Jenis Jabatan <span className="text-danger">*</span>
                </Label>
                <CustomSelect
                    name="jenisJabatan"
                    id="jenisJabatan"
                    errorMessage="Pilih Jenis Jabatan"
                    options={this.state.datajabatannew}
                    placeholder="Pilih Jenis Jabatan"
                    defaultValue={displayData.jenisJabatan}
                    isAvForm={false}
                    isClearable={true}
                  />
              </AvGroup>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md="6">
              <AvGroup>
                <Label htmlFor="kodeJabatan" className="fw-semibold">
                  Kode Jabatan
                </Label>
                <AvField
                  id="kodeJabatan"
                  name="kodeJabatan"
                  type="text"
                  readOnly
                  placeholder="Masukan Kode Jabatan"
                  value={displayData.kodeJabatan}
                  onChange={this.handleChange}
                />
              </AvGroup>
            </Col>
          </Row>

          <Row>
            <Col md="12">
              <AvGroup>
                <Label htmlFor="ikhtisarJabatan" className="fw-semibold">
                  Ikhtisar Jabatan <span className="text-danger">*</span>
                </Label>
                <AvField
                  id="ikhtisarJabatan"
                  name="ikhtisarJabatan"
                  type="textarea"
                  rows={4}
                  value={displayData.ikhtisarJabatan}
                  onChange={this.handleChange}
                  required
                  errorMessage="Ikhtisar Jabatan harus diisi"
                />
              </AvGroup>
            </Col>
          </Row>
          <br/>
          <Row>
            <Col md="12" className="text-end">
              <Button type="submit" color="primary">
                Simpan Data Jabatan
              </Button>
            </Col>
          </Row>
        </AvForm>
      </>
    );
  };

  renderTextareaSection = (label, name) => {
    const { form } = this.state;

    return (
      <>
        <h5 className="mb-3 fw-bold">{label}</h5>
        <AvForm
          className="needs-validation"
          onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
        >
          <Row>
            <Col md="12">
              <AvGroup>
                <Label htmlFor={name} className="fw-semibold">
                  {label} <span className="text-danger">*</span>
                </Label>
                <AvField
                  id={name}
                  name={name}
                  type="textarea"
                  rows={5}
                  value={form[name]}
                  onChange={this.handleChange}
                  required
                  errorMessage={`${label} harus diisi`}
                />
              </AvGroup>
            </Col>
          </Row>
          <br/>
          <Row>
            <Col md="12" className="text-end">
              <Button type="submit" color="primary">
                Simpan {label}
              </Button>
            </Col>
          </Row>
        </AvForm>
      </>
    );
  };

  renderContent = () => {
    const { activeSubTab } = this.state;

    switch (activeSubTab) {
      case "Data Jabatan":
        return this.renderDataJabatan();
      case "Tugas Pokok":
        return this.renderTextareaSection("Tugas Pokok", "tugasPokok");
      case "Hasil Kerja":
        return this.renderTextareaSection("Hasil Kerja", "hasilKerja");
      case "Bahan Kerja":
        return this.renderTextareaSection("Bahan Kerja", "bahanKerja");
      case "Perangkat Kerja":
        return this.renderTextareaSection("Perangkat Kerja", "perangkatKerja");
      case "Tanggung Jawab":
        return this.renderTextareaSection("Tanggung Jawab", "tanggungJawab");
      case "Wewenang":
        return this.renderTextareaSection("Wewenang", "wewenang");
      case "Korelasi Jabatan":
        return this.renderTextareaSection("Korelasi Jabatan", "korelasiJabatan");
      case "Kondisi Ling. Kerja":
        return this.renderTextareaSection("Kondisi Lingkungan Kerja", "kondisiLingKerja");
      case "Resiko Bahaya":
        return this.renderTextareaSection("Resiko Bahaya", "resikoBahaya");
      case "Syarat Jabatan Lain":
        return this.renderTextareaSection("Syarat Jabatan Lain", "syaratJabatanLain");
      case "Prestasi Kerja Diharapkan":
        return this.renderTextareaSection("Prestasi Kerja Diharapkan", "prestasiKerja");
      case "Kelas Jabatan":
        return this.renderTextareaSection("Kelas Jabatan", "kelasJabatan");
      default:
        return null;
    }
  };

  
  LoadingState = () => (
      <div style={{ 
        padding: "80px 0", 
        display: "flex", 
        flexDirection: "column", 
        alignItems: "center", 
        justifyContent: "center", 
        textAlign: "center" 
      }}>
        <Spinner color="primary" style={{ width: "4rem", height: "4rem" }} />
        <h5 className="mt-4 text-muted">Mengambil data...</h5>
      </div>
    );

  EmptyState = () => (
      <div style={{ 
        padding: "80px 0", 
        textAlign: "center", 
        display: "flex", 
        flexDirection: "column", 
        alignItems: "center", 
        justifyContent: "center", 
        color: "#6c757d" 
      }}>
        <h5 className="mt-4">Tidak ada data</h5>
        <p className="text-muted">Silakan pilih unit kerja terlebih dahulu</p>
      </div>
  );

  render() {
    const { loading, detail, activeSubTab } = this.state;

    if (loading) {
      return <this.LoadingState />;
    }

    if (!loading && (!detail || Object.keys(detail).length === 0)) {
       return <this.EmptyState />;
    }

    return (
      <div className="p-3">
        <div className="mb-3 infojabatan-subtabs">
          {SUB_TABS.map((label) => (
            <button
              key={label}
              type="button"
              className={
                "btn btn-sm me-2 mb-2 infojabatan-pill " +
                (activeSubTab === label ? "infojabatan-pill-active" : "btn-outline-primary")
              }
              onClick={() => {
                this.setState({ activeSubTab: label });
                // Load detail data setelah tab berubah
                setTimeout(() => {
                  this.loadDetailByTab();
                }, 0);
              }}
            >
              {label}
            </button>
          ))}
        </div>

        {this.renderContent()}

        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
      </div>
    );
  }
}

export default InfoJabatanComponent;